import {
  useSharedState,
  useSharedStateDispatch,
} from "../contexts/SharedStateContext";

export const useSharedStateWithActions = () => {
  const state = useSharedState();
  const dispatch = useSharedStateDispatch();

  const setValue = <T>(key: string, value: T) =>
    dispatch({ type: "SET_VALUE", key, value });
  const removeValue = (key: string) => dispatch({ type: "REMOVE_VALUE", key });

  return { state, setValue, removeValue };
};
